module.exports = __webpack_public_path__ + "img/thumbnail_Dingo_f_normal.860a665b.png";